export default __webpack_public_path__ + "static/media/alemana.d8889687.svg";